<template>
  <div class="page-agreement">
    <div class="agreement-block">
      <header>
        <svg width="115"
          height="31"
          viewBox="0 0 115 31"
          fill="none"
          class="logo-text"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.2328 20.8923C22.2328 28.0218 19.0444 31 11.5904 31H10.6425C3.18843 31 0 27.7962 0 20.2154V19.2227C0 11.7322 2.97299 8.52838 9.86689 8.52838H10.2978C12.9691 8.52838 14.7788 9.06987 15.9421 9.8821V0H22.2328V20.8923ZM6.40065 19.8639C6.42372 24.3349 7.43724 25.4811 11.1508 25.4811C14.9081 25.4811 15.9446 24.3077 15.9446 19.8401C15.9446 15.2371 14.8218 13.9735 11.0213 13.9735C7.35037 13.9735 6.40025 15.1468 6.40025 19.7047L6.40065 19.8639Z"
            fill="black" />
          <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.2158 0V5.57232H24.9278V0H31.2158ZM31.2158 8.70674V30.6477H24.9277V8.70674H31.2158Z"
            fill="black" />
          <path d="M40.2114 30.6478V18.5137C40.2114 14.9953 41.2039 13.9578 44.6561 13.9578C48.0652 13.9578 49.0577 14.9953 49.0577 18.5137V30.6478H55.3579V17.4762C55.3579 11.116 52.3373 8.45459 45.1308 8.45459H44.1814C36.9318 8.45459 33.9111 11.116 33.9111 17.4762V30.6478H40.2114Z"
            fill="black" />
          <path d="M64.3398 30.6477V0H58.0518V30.6477H64.3398Z"
            fill="black" />
          <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M83.322 28.6912C82.331 29.9588 80.3059 31 77.2037 31H76.7728C69.9651 31 67.0352 27.7857 67.0352 20.2253V19.2293C67.0352 11.6689 70.2236 8.45459 77.6776 8.45459H78.6255C86.0795 8.45459 89.268 11.3973 89.268 18.4144V30.6478H83.322V28.6912ZM73.4356 19.8658C73.458 24.3352 74.4275 25.4811 77.9699 25.4811C81.8136 25.4811 82.9796 24.1724 82.9796 19.434C82.9796 15.1017 81.9431 13.9735 78.1858 13.9735C74.4285 13.9735 73.4352 15.1469 73.4352 19.7048L73.4356 19.8658Z"
            fill="black" />
          <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M114.196 20.2154C114.196 27.7962 111.007 31 103.596 31H102.648C95.1944 31 91.9629 28.0218 91.9629 20.8923V0H98.2536V9.92722C99.4169 9.06987 101.227 8.52838 103.898 8.52838H104.372C111.223 8.52838 114.196 11.7322 114.196 19.2227V20.2154ZM98.3632 19.8401C98.3632 24.3077 99.395 25.4811 103.178 25.4811C106.919 25.4811 107.908 24.3077 107.908 19.7047C107.908 15.1468 106.919 13.9735 103.307 13.9735C99.481 13.9735 98.3632 15.2371 98.3632 19.8401Z"
            fill="black" />
        </svg>
        <h1>用户服务协议</h1>
        <h5>更新时间：2019年12月05日</h5>
        <svg width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          class="logo"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.6292 0.550284L30.4404 4.53579C31.142 5.26951 31.142 6.45909 30.4404 7.1928L26.3116 11.5104C24.9084 12.9779 22.6333 12.9779 21.2301 11.5104L17.4189 7.52493L24.0884 0.550284C24.7901 -0.183428 25.9276 -0.183428 26.6292 0.550284Z"
            fill="#004BFF" />
          <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.9466 24.7954L28.5346 26.456C29.0608 27.0063 29.0608 27.8985 28.5346 28.4488C28.0084 28.9991 27.1552 28.9991 26.629 28.4488L25.041 26.7882L26.9466 24.7954Z"
            fill="#004BFF" />
          <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.0502 15.7615L16.1481 22.1384V22.1384L8.20823 30.4415C7.50661 31.1753 6.36908 31.1753 5.66746 30.4415L0.585938 25.1275L7.95415 17.4222L8.06052 17.3119C8.86966 16.4799 9.53288 15.9631 10.0502 15.7615Z"
            fill="#004BFF" />
          <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.20823 0.550284L19.9593 12.8389C21.3625 14.3064 21.3625 16.6855 19.9593 18.153L16.1481 22.1385L0.585938 5.8643L5.66746 0.550284C6.36908 -0.183428 7.50661 -0.183428 8.20823 0.550284Z"
            fill="black" />
          <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.4081 19.3998L29.4875 19.4815C30.1891 20.2152 30.1891 21.4048 29.4875 22.1385L22.5004 29.4453C21.8085 30.1688 20.6927 30.1789 19.9891 29.4755L19.9596 29.4453C17.3286 26.6939 17.3286 22.233 19.9596 19.4815C22.5643 16.7576 26.7713 16.7304 29.4081 19.3998V19.3998Z"
            fill="black" />
        </svg>
      </header>

      <div>
        <h3>导言</h3>

        <p>欢迎您使用上海芝世信息技术有限公司旗下dinlab平台及服务！</p>

        <p>为使用上海芝世信息技术有限公司旗下dinlab平台及服务（下文简称为“dinlab”），您应当阅读并遵守《dinlab用户服务协议》（以下简称“本协议”）。</p>

        <p>请您务必审慎阅读、充分理解各条款内容，特别是服务变更、中止或终止、免除或者限制责任、管辖与法律适用的条款，以及开通或使用某项服务的单独协议、规则。服务变更、中止或终止、免除或者限制责任以及管辖与法律适用条款可能以黑体加粗形式提示您注意。</p>

        <p>除非您已阅读并接受本协议所有条款，否则您无权使用dinlab平台及服务。您使用本服务即视为您已阅读并同意本协议的约束。 如果您未满18周岁，请在法定监护人的陪同下阅读本协议及其他上述协议，并特别注意未成年人使用条款。</p>

        <h3>一、协议的范围</h3>

        <h4>1.1 协议适用主体范围</h4>

        <p>本协议是您与上海芝世信息技术有限公司之间关于您使用dinlab平台及服务所订立的协议。</p>

        <p>“dinlab用户”是指通过使用上海芝世信息技术有限公司公司相关产品和服务的个人或组织。</p>

        <h3>二、关于本服务</h3>

        <h4>2.1 本服务内容</h4>

        <p>本服务内容是指上海芝世信息技术有限公司以及包含旗下所有经营的有关教育、学习等数字内容聚合、管理和分发的平台产品，旨在为用户提供教学内容的生成、传播和消费服务。</p>

        <h4>2.2 本服务形式</h4>

        <p>
          您进入dinlab网站（ https://www.dinlab.cn ）使用微信号或手机号登录并同意本协议即可使用本服务。
        </p>

        <h3>三、账户使用规则</h3>

        <p>
          <strong>3.1 帐号登录：</strong>您可浏览dinlab的课程信息，如您希望学习该课程，您需先登录您的帐号，如您选用其他第三方帐号，您应保证第三方帐号的稳定性、真实性以及可用性，如因第三方帐号原因（如第三方帐号被封号）致使您无法登录，您应与第三方帐号的所属公司联系。您在学习课程时登录的帐号是dinlab确认您身份的唯一依据。
        </p>

        <p>
          <strong>3.2 用户确认：</strong>用户是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织，有能力对用户使用dinlab服务的一切行为独立承担责任。若用户不具备前述主体资格，dinlab在依据法律规定或本协议约定要求用户承担责任时，有权向用户的监护人追偿。
        </p>

        <p>3.3 您在使用dinlab服务时填写、登录、使用的帐号名称、头像、个人简介等帐号信息资料应遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在帐号信息资料中出现违法和不良信息，且您保证在填写、登录、使用帐号信息资料时，不得有以下情形:</p>

        <p>（1）违反宪法或法律法规规定的；</p>

        <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>

        <p>（3）损害国家荣誉和利益的，损害公共利益的；</p>

        <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>

        <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>

        <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>

        <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>

        <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>

        <p>（9）含有法律、行政法规禁止的其他内容的。</p>

        <p>若您登录、使用帐号头像、个人简介等帐号信息资料存在违法和不良信息的，dinlab有权采取通知限期改正、暂停使用等措施。对于冒用关联机构或社会名人登录、使用、填写帐号名称、头像、个人简介的，dinlab有权取消该帐号在dinlab上使用，并向政府主管部门进行报告。</p>

        <p>3.4 您应保管好自己的帐号和密码，如因您未保管好自己的帐号和密码而对自己、dinlab或第三方造成损害的，您将自负全部责任。另外，您应对您帐号中的所有活动和事件负全责。您可随时改变帐号的密码。您同意若发现有非法使用您的帐号或出现安全漏洞的情况，立即通告dinlab，dinlab将会尽力予以妥善解决。</p>

        <h3>四、课程相关</h3>

        <h4>4.1 dinlab服务产品版权用户应遵守以下条款</h4>

        <p>你需充分理解并同意，dinlab享有与教字内容相关的信息、资料等的所有版权，版权保护范围包括dinlab以任何形式获取的与教学内容相关的一切信息、资料等，呈现形式及载体包括但不限于书面、口头、图片、视频、音频、文件、电子邮件、报告、文字往来、笔记及其它媒体等。用户承诺对以任何形式接触到的与教学内容相关的一切信息、资料等承担严格的保密义务，未经dinlab书面同意，用户不得擅自下载、转录、重制、剪切、引用与教学内容相关的任何信息；不得以公布、发表、出版、转让或者其他任何方式，使第三方知悉或有机会使用与教学内容相关的任何信息、资料等。一经发现上述侵权行为，用户认可并接受赔偿dinlab课程价值100倍损失。</p>

        <p>4.2 课程服务的内容请参阅课程对外公示的详细介绍。</p>

        <p>4.3 课程服务的终止时间在最后一堂直播课程结束后两周。</p>

        <p>4.4 课程的录屏在课程服务结束后还会持续保留，dinlab有权因版权问题或课程升级等其他特殊原因关闭课程录屏的回放权限。</p>

        <p>4.5 您需要自备学习课程所需要的硬件设备与软件，若因您自身问题造成无法完全享受课程服务，责任由您自身承担。</p>

        <p>4.6 dinlab有权因技术故障或者其他特殊原因适当调整课程的授课时间，但dinlab将确保学生能够完整相受到课程所承诺的所有服务。</p>

        <p>4.7 您在学习过程中应当友善交流，遵守课程秩序，言语中不应当涉及人身攻击，或发表谈论政治、色情、赌博等不当言论。若言行不当，dinlab有权单方面暂停或者取消该用户的课程服务。</p>

        <h3>五、作品相关</h3>

        <p>
          <em>5.1 您在dinlab平台参与课程创作的作品，以及主题打卡活动作品，作品的著作权仍归您本人所有，dinlab拥有线上课程及活动作品进行展示、报道、宣传及用于市场活动的权利，我们提倡并鼓励每位创作者保持作品署名的良好习惯，以便后续传播中您个人的品牌露出。dinlab如需对该作品进行开发、生产、销售等商业用途，需取得您的书面许可，并向您支付相应设计费用。</em>
        </p>

        <p>
          <em>5.2您在dinlab平台上传的作业或活动打卡均须为原创，不得抄袭、盗用他人作品，应遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在帐号信息资料中出现违法和不良信息。如有临摹也务必标注出处。如作品中含有素材元素&lt;非原创部分&gt;，您需拥有该素材版权的使用授权许可，若在平台发生版权纠纷，其法律责任由您本人承担。</em>
        </p>

        <h3>六、数据相关</h3>

        <p>6.1 如果您在18周岁以下，则只能在父母或监护人的监护参与下才能使用课程服务。若您不具备该主体资格，则您的监护人应承担因此而导致的一切后果。</p>

        <p>
          <em>6.2 为课程保密需要，课程报名流程中需要提供个人身份信息进行审核，并签署课程保密协议，以此维护老师与用户的权益。</em>
        </p>

        <p>6.3 dinlab承诺对获得的用户的个人信息尽最大努力进行保护，不会泄露用户的个人身份隐私信息，或作为其他用途使用。我们通过以下方式对您的资料进行严格保护：</p>

        <p>6.3.1 使用合规实名认证接口，确保信息安全。</p>

        <p>6.3.2 数据库安全性经过严格验证，保证数据的高度私密性和安全性。</p>

        <p>6.3.3 后台权限分离，个人资料审核由核心员工担任，且个人资料无法导出。</p>

        <p>6.3.4 一般管理员仅能获取用户认证状态，无法接触个人资料。</p>

        <p>6.3.5 dinlab承诺，采集的实名信息仅用作发生侵权问题时的维权使用，不得用作营销或其他行为。</p>

        <p>6.4 除非另有证明，dinlab储存在其服务器上的数据是您使用dinlab服务的唯一有效证据。</p>

        <h3>七、 dinlab产品使用规则</h3>

        <p>7.1 您须对自己在使用dinlab服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿；以及在dinlab首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予dinlab等额的赔偿。</p>

        <p>7.2 您了解并同意，dinlab有权应有关部门的要求，向其提供您提交给dinlab或在使用dinlab课程服务中存储于dinlab服务器的必要信息。如您涉嫌侵犯他人合法权益，则dinlab有权在初步判断涉嫌侵权行为存在的情况下，向权利人提供关于您的前述必要信息。</p>

        <h3>八、退款相关</h3>

        <p>
          <em>8.1 如您需要退款，自购买课程之日起三个自然日(72小时)内，且未正式开课前，您可申请全额退款。</em>
        </p>

        <p>
          <em>8.2 课程购买超过3天后，或课程已开课，dinlab一律不接受退款。</em>
        </p>

        <p>8.3 课程相关的保密条款不会因为退款而失效。</p>

        <p>8.4 退款因为不同支付渠道，退款周期在7-30个工作日不等。</p>

        <h3>九、其他约定</h3>

        <p>
          <strong>9.1 不可抗力：</strong>
        </p>

        <p>dinlab对不可抗力导致的损失不承担责任。本服务条款所指不可抗力包括：天灾、法律法规或政府指令的变更，因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、互联网覆盖范围限制、计算机病毒、黑客攻击等因素，及其他合法范围内的不能预见、不能避免并不能克服的客观情况。</p>

        <p>
          <strong>9.2 服务中止、中断及终止：</strong> dinlab根据自身商业决策等原因可能会选择中止、中断及中止平台服务。如有此等情形发生，dinlab会采取公告的形式通知您。经国家行政或司法机关的生效法律文书确认您存在违法或侵权行为，或者dinlab根据自身的判断，认为您的行为涉嫌违反本协议内容或dinlab不时公布的使用规则等内容，或涉嫌违反法律法规的规定的，则dinlab有权中止、中断或终止向您提供服务，且无须为此向您或任何第三方承担责任。
        </p>

        <p>
          <strong>9.3 所有权及知识产权：</strong>dinlab平台上所有内容，包括但不限于文字、软件、声音、图片、录像、图表、网站架构、网站画面的安排、网页设计、dinlab为您提供的标有“版权所有，禁止转载”字样的教育内容均由dinlab或其他权利人依法拥有其知识产权，包括但不限于著作权、商标权、专利权等。非经dinlab或其他权利人书面同意您不得擅自使用、修改、复制、传播、改变、散布、发行或发表上述内容。如有违反，您同意承担由此给dinlab或其他权利人造成的一切损失。
        </p>

        <p>
          <strong>9.4 通知：</strong>所有发给您的通知都可通过电子邮件、短信、常规的信件或在网站显著位置公告的方式进行传送。
        </p>

        <p>
          <strong>9.5 本协议适用中华人民共和国的法律（不含冲突法）。</strong> 当本协议的任何内容与中华人民共和国法律相抵触时，应当以法律规定为准，同时相关内容将按法律规定进行修改或重新解释，而本协议其他部分的法律效力不变。
        </p>

        <p>
          <strong>9.6 本协议自发布之日起实施，并构成您和dinlab之间的共识。</strong>
        </p>

        <p>
          <strong>9.7 dinlab不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响dinlab在将来行使该权利。</strong>
        </p>

        <h4>上海芝世信息技术有限公司</h4>
      </div>
    </div>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
  import { TITLE_SUFFIX } from "../constant/constant";
  import TheFooter from '../components/TheFooter';

  export default {
    name: "agreement",
    components: {
      TheFooter
    },
    created() {
      document.title = '服务协议' + TITLE_SUFFIX;
    }
  }
</script>

<style lang="scss">
  .page-agreement {
    background: #f5f5f5;
    padding-top: 100px;
    .agreement-block {
      padding: 100px 100px 150px;
      background: #fff;
      text-align: left;
      width: 70%;
      max-width: 960px;
      margin: 0 auto;
      font-size: 0.875rem;
      color: #42454d;
      border-radius: 20px;
      margin-bottom: 200px;
      header {
        width: 100%;
        height: 240px;
        position: relative;
        border-bottom: 1px solid #ced1d9;
        margin-bottom: 40px;
        svg.logo-text {
          position: absolute;
        }
        svg.logo {
          position: absolute;
          right: 0;
          top: 0;
          transform: scale(1.6);
          transform-origin: right top;
        }
        h1 {
          font-size: 52px;
          font-weight: 300;
          letter-spacing: 2px;
          padding-top: 60px;
          margin-bottom: 10px;
        }
        h5 {
          font-size: 18px;
          font-weight: 400;
          color: #838999;
        }
      }

      h3 {
        font-size: 24px;
        letter-spacing: 1px;
        font-weight: 600;
        line-height: 3;
        margin-top: 20px;
      }
      h4 {
        font-size: 20px;
        letter-spacing: 1px;
        font-weight: 600;
        line-height: 3;
        margin-bottom: 10px;
      }

      p {
        font-size: 16px;
        letter-spacing: 1.6px;
        font-weight: 400;
        line-height: 2;
        margin-bottom: 10px;
        color: #838999;
        text-align: justify;
        strong {
          font-weight: 600;
        }
        em {
          font-style: normal;
          background: #fffdcb;
        }
      }
      .bold-text {
        font-weight: bold;
      }
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1199px) {
    .agreement-block {
      width: 80%;
      padding: 70px 70px 100px;
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    .agreement-block {
      width: 86%;
      padding: 50px 50px 80px;
      p {
        font-size: 14px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .page-agreement {
      padding-top: 40px;
      .agreement-block {
        padding: 40px 30px 40px;
        background: #fff;
        text-align: left;
        width: 92%;
        margin: 0 4%;
        margin: 0 auto 80px;
        border-radius: 12px;
        header {
          width: 100%;
          height: 170px;
          position: relative;
          border-bottom: 1px solid #ced1d9;
          margin-bottom: 40px;
          svg.logo-text {
            position: absolute;
            transform: scale(0.75);
            transform-origin: left top;
          }
          svg.logo {
            position: absolute;
            right: 0;
            top: 0;
            transform: scale(0.75);
            transform-origin: right top;
          }
          h1 {
            font-size: 32px;
            font-weight: 300;
            letter-spacing: 2px;
            padding-top: 60px;
            margin-bottom: 10px;
          }
          h5 {
            font-size: 14px;
            font-weight: 400;
            color: #838999;
          }
        }

        h3 {
          font-size: 20px;
          letter-spacing: 1px;
          font-weight: 600;
          line-height: 3;
          margin-top: 20px;
        }
        h4 {
          font-size: 16px;
          letter-spacing: 1px;
          font-weight: 600;
          line-height: 3;
          margin-bottom: 10px;
        }

        p {
          font-size: 12px;
          letter-spacing: 1px;
          font-weight: 400;
          line-height: 2;
          margin-bottom: 10px;
          color: #838999;
          strong {
            font-weight: 600;
          }
          em {
            font-style: normal;
            background: #fffdcb;
          }
        }
        .bold-text {
          font-weight: bold;
        }
      }
    }
  }
</style>
